import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback } from 'react';
import { propBool, propShape, propStr, } from '../../../../../helpers/custom-prop-types';
import ColumnCheckBox from './ColumnCheckBox';
const ColumnSyncCheckBox = (props) => {
    const { check, especially, isDisabled, label } = props;
    const wrapOnChange = useCallback((e) => {
        const { checked } = e.currentTarget;
        if (!checked) {
            especially.input.onChange(false);
        }
    }, [especially.input]);
    return (_jsx(ColumnCheckBox, { input: check.input, isDisabled: isDisabled, label: label, meta: check.meta, wrapOnChange: wrapOnChange }));
};
ColumnSyncCheckBox.propTypes = {
    check: propShape().isRequired,
    especially: propShape().isRequired,
    isDisabled: propBool().isRequired,
    label: propStr().isRequired,
};
export default ColumnSyncCheckBox;
